import { BaseEntity } from 'src/app/tools/models/baseEntity';
import { Product } from 'src/app/assabil-kernel/models/entities/master-data/product-entity';


export class WarehouseInventoryLine extends BaseEntity {
  
  warehouseInventoryCode    : string;
  product                   : Product;
  productBatchCode          : string = "?";
  
  availableQuantity         : number = 0;
  damagedQuantity1          : number = 0;
  damagedQuantity2          : number = 0;
  expiringDate              : Date;


  availableQuantityT         : number = 0;
  damagedQuantity1T          : number = 0;
  damagedQuantity2T          : number = 0;

  constructor() {
    super()
  }
 
}
 


